import React from 'react';
import WithConsumer from '../context/WithConsumer';

const ProductDownload = ({ context }) => {
	
	if (context.posts){
		
	    const posts = () => context.posts;
	    const item = posts()[0];  
	    
		let fileURLs = [];
		let zip = require('jszip')();
		let count = 0;
		
		if (item.gallery) {
			for (let i=0;i<item.gallery.length;i++) {
				fileURLs.push(item.gallery[i].srclrg);
			}
		}
		
		function handleDownload(evt) {
			evt.preventDefault();
			for (let i=0;i<fileURLs.length;i++) {
				document.getElementsByClassName('download-' + i)[0].click();
			}
		}
	
		return (
			<>
				<a href="#" className="c-product__download" onClick={handleDownload}>Download Images</a>
				{fileURLs.map((file,i) =>
					{
						return (
							<a className={'download-' + i} href={file} download={item.title + "-" + i} style={{display:'none'}}></a>
						)
					}
				)}
			</>
		)

	} else {
		return null;
	}
}
export default WithConsumer(ProductDownload);